import { useModalPromises } from "kreate-common/modules/kreate-ui/components/Modal/hoc/withModalPromises";

import ModalUpdateListingDetailsConfirmation, {
  ModalUpdateListingDetailsConfirmation$SubmitEvent,
} from ".";

export function useModalTrigger$ModalUpdateListingDetailsConfirmation() {
  const { showModal } = useModalPromises();

  const openModal = async (
    props: Omit<
      React.ComponentProps<typeof ModalUpdateListingDetailsConfirmation>,
      "open" | "onCancel" | "onSubmit"
    >
  ) => {
    return await showModal<ModalUpdateListingDetailsConfirmation$SubmitEvent>(
      ({ resolve, reject }) => (
        <ModalUpdateListingDetailsConfirmation
          open
          onCancel={() => reject(null)}
          onSubmit={(event) => resolve(event)}
          {...props}
        />
      )
    );
  };
  return { openModal };
}
